/* eslint-disable max-len */
import React from 'react'
import SvgIcon from './SvgIcon'

export default props => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.7,2c0.4,0,0.7,0.1,1,0.4l8.6,8.6c0.6,0.6,0.6,1.5,0,2l-8.6,8.6c-0.6,0.6-1.5,
      0.6-2,0c-0.6-0.6-0.6-1.5,0-2l7.6-7.6 L6.7,4.4c-0.6-0.6-0.6-1.5,
      0-2C7,2.1,7.3,2,7.7,2z"
      />
    </SvgIcon>
  )
}
